import React from "react";
import MomentUtils from "@date-io/moment";
import "moment/locale/uk";
import CalendarTodayOutlined from '@material-ui/icons/CalendarTodayOutlined'
import {locale, Moment} from "moment";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import classNames from "classnames";
import {FormControl} from "@material-ui/core";
import {IFormattedResponse} from "../../../model/parametrizedResponse";
import "./index.scss";
import {KeyboardDatePickerProps} from "@material-ui/pickers/DatePicker/DatePicker";
import moment from "moment/moment";

interface Props extends Omit<KeyboardDatePickerProps, 'onChange' | 'value'> {
    value?: string | Date | null;
    placeholder?: string;
    label?: string;
    minDate?: Date;
    maxDate?: Date;
    format?: string;
    returnFormat?: string;
    disabled?: boolean;
    hidden?: boolean;
    validationError?: string;
    onChange?: (value: string) => void;
    formatResponse?: (obj: any) => IFormattedResponse;
    defaultValue?: any;
}

export const DatePicker = (props: Props) => {
    const {
        name,
        value,
        label,
        placeholder,
        disabled,
        hidden,
        error,
        validationError,
        minDate,
        maxDate,
        format = "DD.MM.YYYY",
        returnFormat = "YYYY-MM-DD",
        onChange,
        formatResponse,
        ...rest
    } = props;

    const locLocale= ()=> {
        if(process.env.REACT_APP_LANG==='ua') {
            return locale('uk');
        }else {
            return locale('en');
        }
    }

    const handleChange = (date: Moment | null) => {
        if (date?.isValid()) {
            const normalizedValue = moment(date).format(returnFormat);
            onChange?.(normalizedValue ?? null);
        }
    };

    const className = classNames({
        "date-select": true,
    });

    return (
        <FormControl className={'select-one-input__select'} error={error} variant="outlined" fullWidth={true}>
            <MuiPickersUtilsProvider utils={MomentUtils} locale={locLocale()}>
                <div className={className} hidden={hidden}>
                    <div className={'date-select__input'}>
                        <KeyboardDatePicker
                            {...rest}
                            value={value}
                            id={name}
                            autoOk
                            variant="inline"
                            minDate={minDate}
                            maxDate={maxDate}
                            label={label}
                            InputLabelProps={{
                                style: {
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    width: '92%'
                                }
                            }}
                            inputVariant="outlined"
                            placeholder={placeholder}
                            fullWidth={true}
                            format={format}
                            disabled={disabled}
                            helperText={error && validationError}
                            error={error}
                            onChange={handleChange}
                            keyboardIcon={<CalendarTodayOutlined htmlColor={'#9E9C9A'}/>}
                            PopoverProps={{
                                transitionDuration: 0,
                            }}
                        />
                    </div>
                </div>
            </MuiPickersUtilsProvider>
        </FormControl>
    )
};
